import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useSearchContextHeader } from 'containers/SearchContextHeader/useSearchContextHeader';
import { LoadingPage } from 'modules/main/pages/Loading';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { partialUpdateOrg } from 'modules/main/store/slices/orgsSlice';
import { fetchOrg } from 'modules/main/store/slices/orgsSlice.actions';
import { orgDashboardApiPartialUpdateOrg as apiUpdateOrg } from 'modules/orgDashboard/api/orgDashboardApiOrg';
import { setDocumentTitle } from 'utils/meta/setDocumentTitle';
import { scrollToHash } from 'utils/scrollIntoView';

import { ViewOrgPage } from './ViewOrgPage';
import { ViewOrgPageUnpublished } from './components/ViewOrgPageUnpublished';
import { trackViewOrgPageView } from './trackViewOrgPageView';

type Props = {
  orgId: string;
};

export function ViewOrgPageContainer({ orgId }: Props) {
  const dispatch = useMainDispatch();
  const location = useLocation();
  const { org, isUnpublished } = useMainSelector(
    (state) => state.orgs.byId[orgId] || {},
  );

  useEffect(() => {
    if (!org) {
      dispatch(fetchOrg(orgId));
    }

    if (org && org.type === 'ORG') {
      trackViewOrgPageView(org);
      setDocumentTitle(org.name);
    }

    setTimeout(() => {
      scrollToHash(location.hash.replace('section-', ''));
    }, 1);
  }, [dispatch, location.hash, org, orgId]);

  const onSubmit = ({
    values,
    handleError,
  }: {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: Record<string, any>;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError: (...args: Array<any>) => any;
  }) => {
    apiUpdateOrg(values)
      .then(() => {
        dispatch(partialUpdateOrg(values));
      })
      .catch(handleError);
  };

  const { searchContext } = useSearchContextHeader({ currentObjectId: orgId });

  if (org?.type === 'UNPUBLISHED_ORG' || isUnpublished) {
    return (
      <ViewOrgPageUnpublished
        url={undefined}
        orgId={undefined}
        searchContext={searchContext}
      />
    );
  }

  if (!org) {
    return <LoadingPage />;
  }

  return (
    <ViewOrgPage
      org={org}
      searchContext={searchContext}
      isPublished
      onSubmit={onSubmit}
    />
  );
}
